import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import Breadcrumb, { BreadcrumbPlaceholder } from './components/Breadcrumb';
const GET_BREADCRUMB = gql`
  query getBreadcrumb(
    $referrer: String
    $productId: Int
    $categoryId: Int
    $collectionId: Int
  ) {
    getBreadcrumb(
      referrer: $referrer
      productId: $productId
      categoryId: $categoryId
      collectionId: $collectionId
    ) {
      link
      label
    }
  }
`;
const ConsumerBreadcrumb = ({
  config = {
    items: [],
    productVisualization: false
  },
  location,
  layout,
  color,
  forPage,
  withSchema = true
}) => {
  const {
    productId,
    categoryId,
    collectionId,
    variantId
  } = config;
  const referrer = useMemo(() => {
    if (productId) {
      return location.state ? location.state.prevPath : null;
    }
    if (categoryId || collectionId) {
      return location.pathname;
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, categoryId, collectionId]);
  const {
    loading,
    data,
    error
  } = useSuspenseQuery(GET_BREADCRUMB, {
    variables: {
      referrer,
      productId,
      categoryId,
      collectionId
    },
    skip: !productId && !categoryId && !collectionId
  });
  if (!productId && !categoryId && !collectionId) {
    return <Breadcrumb items={config.items} color={color} forPage={forPage} withSchema={withSchema} />;
  }
  if (loading) {
    return <BreadcrumbPlaceholder layout={layout} forPage={forPage} />;
  }
  if (error || !data.getBreadcrumb) return null;
  let items = data.getBreadcrumb;
  if (config.productVisualization) {
    items = items.concat({
      label: 'Product Visualization'
    });
  }
  return <Breadcrumb items={items} layout={layout} color={color} forPage={forPage} variantId={variantId} withSchema={withSchema} />;
};
ConsumerBreadcrumb.propTypes = {
  color: PropTypes.string,
  config: PropTypes.shape({
    categoryId: PropTypes.number,
    collectionId: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })),
    productId: PropTypes.number,
    productVisualization: PropTypes.bool,
    variantId: PropTypes.string
  }),
  forPage: PropTypes.string,
  layout: PropTypes.string,
  withSchema: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.shape({
      prevPath: PropTypes.string
    })
  })
};
export { BreadcrumbPlaceholder };
export default ConsumerBreadcrumb;